export default __webpack_public_path__ + "static/media/70.b08e139b.png";